import React from 'react';
import { Link } from 'react-router-dom';
import { resolveApiAssetUrl } from '../lib/api';
import { useSettings } from '../context/SettingsContext';
import { useVisibleHomeCategories } from '../lib/homeCategories';
import { Dices, Gift, Rocket, Trophy, Video } from 'lucide-react';
import { HOOKS, SECTIONS, hook, sectionHook } from '../lib/domHooks';

// İkon kart anahtarından seçilir; panelden eklenen özel kartlar zar ikonuna düşer.
const categoryIcons = {
  slot: Dices,
  canli: Video,
  spor: Trophy,
  bonus: Gift,
  crash: Rocket,
};

const CategoryCards = () => {
  const settings = useSettings();
  const visibleCategories = useVisibleHomeCategories(settings.sports_enabled);

  const columns = visibleCategories.length <= 2
    ? 'md:grid-cols-2'
    : visibleCategories.length === 3 ? 'md:grid-cols-3' : 'md:grid-cols-4';

  if (visibleCategories.length === 0) return null;

  return (
    <div
      className={`home-category-grid grid grid-cols-2 ${columns} gap-3 md:gap-4`}
      {...sectionHook(SECTIONS.CATEGORIES)}
    >
      {visibleCategories.map((c) => {
        const Icon = categoryIcons[c.card_key] || Dices;
        return (
          <Link
            key={c.id}
            to={c.href || '/'}
            {...hook(HOOKS.CATEGORY_CARD)}
            className="cat-card group block"
          >
            {c.image && (
              <img
                src={resolveApiAssetUrl(c.image)}
                alt={c.title}
                className="absolute inset-0 w-full h-full object-cover"
              />
            )}
            <div className="cat-card-copy absolute inset-x-0 bottom-0 p-3.5 md:p-4 z-10">
              <div className="flex items-center gap-2.5">
                <span className="cat-card-icon"><Icon size={16} /></span>
                <div className="min-w-0">
                  <div className="text-xs md:text-sm font-black gold-text leading-none">{c.title}</div>
                  <div className="text-sm md:text-lg font-black text-white leading-none mt-1 truncate">{c.subtitle}</div>
                </div>
                <span className="cat-card-arrow ml-auto" aria-hidden="true">→</span>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default CategoryCards;
